import React from 'react';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { ChefQuote } from '../components/ChefQuote';
import { HoursLocation } from '../components/HoursLocation';
import { Contact } from '../components/Contact';
export function Home() {
  return <>
      <Hero data-id="element-249" data-mp="2x67oawz39msl" />
      <About data-id="element-250" data-mp="2x5zb13z20fgv" />
      <ChefQuote data-id="element-251" data-mp="2x4eg3d8tuuih" />
      <HoursLocation data-id="element-252" data-mp="2x4wjquxtkb0f" />
      <Contact data-id="element-253" data-mp="2x7iqiscvymhl" />
    </>;
}